var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPollsIndice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 55,
    viewBox: "0 0 83 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 33.3467,
    r: 20,
    stroke: "url(#paint0_linear_10099_6839)",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.2629 34.6221C47.0014 35.1086 47.1837 35.7149 47.6702 35.9764L55.5972 40.2381C56.0837 40.4996 56.69 40.3173 56.9515 39.8308C57.213 39.3444 57.0307 38.738 56.5442 38.4765L49.498 34.6884L53.2861 27.6421C53.5477 27.1557 53.3653 26.5493 52.8789 26.2878C52.3924 26.0263 51.7861 26.2086 51.5246 26.6951L47.2629 34.6221ZM73.3463 1.06518C74.0394 11.6177 72.6322 18.2766 68.7244 23.0712C64.7838 27.9061 58.1509 31.042 47.8557 34.138L48.4317 36.0533C58.7538 32.9492 65.92 29.6777 70.2747 24.3348C74.6622 18.9517 76.0466 11.6626 75.342 0.934106L73.3463 1.06518Z",
    fill: "url(#paint1_linear_10099_6839)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10099_6839",
    x1: 33.4744,
    y1: 12.3467,
    x2: -0.529368,
    y2: 31.2445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A64FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6370E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10099_6839",
    x1: 61.3914,
    y1: 34.2676,
    x2: 52.6625,
    y2: 18.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A64FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6370E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPollsIndice);
export default __webpack_public_path__ + "static/media/polls-indice.0ec6cd7deca5c43b85a0ed4d8a97ce8e.svg";
export { ForwardRef as ReactComponent };